import { observer } from 'mobx-react-lite';
import { useResolve } from '@/tsyringe-hooks/useResolve';
import { UsersDialogStore, TOKEN_UsersDialogStore } from './UsersDialogStore';
import { Button } from '@/components/ui/button';
import { CircleOff, Unplug } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const UsersDialogView = observer(() => {
    const store = useResolve<UsersDialogStore>(TOKEN_UsersDialogStore);
    const { t } = useTranslation();

    return (
        <div>
            <h3 className="">You are '{store.me?.username}'</h3>
            <p className="mb-4">You have {store.me?.accessLevelDisplay} access to this project.</p>
            <p className="ml-2 mb-4">
                <Button leftIcon={<Unplug />} variant='destructive' onClick={store.leaveProject}>{t('leave_project')}</Button>
            </p>
            {store.otherUsers.length > 0 && <h3>{t('other_users')}</h3>}
            {store.otherUsers.map((userStore) => (
                <div
                    className="flex items-center mb-2 mt-2"
                    key={userStore.id}
                >
                    <div className="mr-4 flex-shrink-0" style={{ backgroundColor: userStore.lastColor, width: '50px', height: '50px' }}></div>
                    <div className="flex-grow truncate">
                        <h4>{userStore.username}</h4>
                        <p>
                            {userStore.isOnline ? `${userStore.accessLevelDisplay} - ${t('online')}` : `${userStore.accessLevelDisplay} - last seen ${userStore.lastSeen}`}
                        </p>
                    </div>
                    {store.isOwner && (
                        <Button
                            title="Disable User"
                            size="iconsm"
                            variant="destructive"
                            onClick={userStore.disableUser}
                            className="ml-auto"
                        >
                            <CircleOff />
                        </Button>
                    )}
                </div>
            ))}
        </div>
    );


});

export default UsersDialogView;